// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"62d9b6bbeb03f8f9","8829":"ec364ee0ea98d249"}[chunkId] + ".css";
};